<template>
  <div class="px-list-box">
    <Header :pageTitle="columnName" />
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="px-list" v-if="loading || articleList.length > 0">
        <PxItem
          class="px-list-item"
          v-for="item in articleList"
          :key="item.id"
          :cover="item.cover"
          :title="item.title"
          :price="item.curriculumPrice"
          :saleType="item.saleType"
          :author="item.publisher"
          :number="item.enrollment"
          @click.native="toDetail(item.id, item.goodsId)"
        />
      </div>
      <noneList noneType="pxList" v-else />
    </van-list>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
import PxItem from "@/views/mobileView/components/listItem/pxItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  components: {
    Header,
    PxItem,
    noneList,
  },
  data() {
    return {
      columnName: "",
      Params: {
        pageNo: 0,
        pageSize: 20,
      },
      articleList: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  created() {
    this.getColumnName();
  },
  methods: {
    // 获取栏目名称 (课程id为15)
    async getColumnName() {
      const resp = await this.$apis.searchServe.getNavList();
      resp.data.forEach((item) => {
        if (item.id === "15") this.columnName = item.columnName;
      });
    },
    // 触底加载
    onLoad() {
      this.Params.pageNo += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      if (this.Params.pageNo == 1) {
        this.Params.beginDateTime = this.$global.transferDate(new Date());
      }
      const resp = await this.$apis.listServe.getJypxList(this.Params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        this.articleList.push(...resp.data.list);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id, goodsId) {
      this.$router.push({
        path: "courseDetails",
        query: { type: 9, id, goodsId },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.px-list-box {
  padding-top: 44px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .px-list {
    margin-top: 12px;
    .px-list-item {
      display: inline-block;
      margin: 12px 10px 0 12px;
      width: 170px;
      border-radius: 6px;
      background-color: #fff;
      overflow: hidden;
      &:nth-child(2n) {
        margin-left: 1px;
        margin-right: 10px;
      }
    }
  }
}
</style>